import Vue from 'vue'
import Vuetify from "vuetify"
import VueI18n from 'vue-i18n'
import store from "@/store"
import { firestorePlugin } from "vuefire"
import { LINDENBERG_THEME } from "@/plugins/themes"

Vue.use(firestorePlugin)
Vue.use(Vuetify)
Vue.use(VueI18n)

export default new Vuetify({
  theme: {
    dark: store.getters["global/isDarkTheme"] != null
      ? store.getters["global/isDarkTheme"]
      : window.matchMedia("(prefers-color-scheme: dark)").matches,
    themes: LINDENBERG_THEME
  }
}
)
